import { inRange, memoize } from '@cian/newbuilding-utils';

export const inRangeMemo = memoize(inRange);
